import { Col, Row } from "react-bootstrap";
import "../../styles/Trip.css";
import { formatDate } from "../../utils/helper";
import { dollarIcon, refuelingIcon, totalRefuelingIcon } from "../../utils/svgs";

const formatFuelAmount = (value) => {
    const amount = Number(value);
    if (!Number.isFinite(amount)) return "";

    return amount.toLocaleString("en-US", {
        maximumFractionDigits: 2,
    });
};

const getFuelPricePerLiter = (event) =>
    event?.fuel_price ?? event?.fuel_price_per_ltr ?? event?.fuel_price_per_liter;

const FuelTimeline = ({ fuelGeneralDetailsData, totalFuelCost, totalClaimedFuel }) => {
    return (
        <div className="trip_tracker_container">
            <div className="timeline_scroll_wrapper">
                <div className="timeline_track">
                    {fuelGeneralDetailsData && fuelGeneralDetailsData?.length > 0 ? (
                        fuelGeneralDetailsData?.map((event, index) => {
                            const isLast = index === fuelGeneralDetailsData?.length - 1;
                            const fuelPrice = getFuelPricePerLiter(event);
                            const formattedFuelPrice = formatFuelAmount(fuelPrice);

                            return (
                                <div key={index} className="timeline_step_wrapper">
                                    <div className={`timeline_step`}>
                                        <div className="step_icon_circle">
                                            <span>{refuelingIcon}</span>
                                        </div>
                                        {!isLast && <div className="step_connector"></div>}
                                    </div>

                                    <div className="step_info">
                                        <p className="step_title">{event?.claimed_fueled} Liters</p>
                                        <p className="step_time">
                                            {formatDate(event?.refuel_at)}
                                        </p>
                                        {event.fuel_station && (
                                            <p className="step_location">{event?.fuel_station?.name + ", " + event?.fuel_station?.location}</p>
                                        )}

                                        <div className="step_tags">
                                            <span className="step_tag speed_tag">
                                                {event?.total_fuel_cost} PKR
                                            </span>
                                            {formattedFuelPrice && (
                                                <span className="step_tag speed_tag">
                                                    {formattedFuelPrice} PKR/L
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            );
                        })
                    ) : (
                        <div className="no_timeline_data">No timeline data available.</div>
                    )}
                </div>
            </div>

            <div className="fuel_summary_section mt-4">
                <Row>
                    <Col md={6}>
                        <div className="summary_card">
                            <div>
                                {totalRefuelingIcon}
                                <p>Total Refuelling <span>(Liters)</span></p>
                            </div>
                            <h6>{totalClaimedFuel}</h6>
                        </div>
                    </Col>

                    <Col md={6}>
                        <div className="summary_card">
                            <div>
                                {dollarIcon}
                                <p>Total Amount <span>(PKR)</span></p>
                            </div>
                            <h6>{totalFuelCost}</h6>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    );
};

export default FuelTimeline;
